export var RestoreMethod;
(function (RestoreMethod) {
    RestoreMethod["RESTORE_METHOD_UNSPECIFIED"] = "RESTORE_METHOD_UNSPECIFIED";
    RestoreMethod["RESTORE_METHOD_AUTO"] = "RESTORE_METHOD_AUTO";
    RestoreMethod["RESTORE_METHOD_IMPORT_TABLE"] = "RESTORE_METHOD_IMPORT_TABLE";
    RestoreMethod["RESTORE_METHOD_CAPACITY_BASED"] = "RESTORE_METHOD_CAPACITY_BASED";
})(RestoreMethod || (RestoreMethod = {}));
